<template>
  <div class="ele-body">
    <div class="main-container">
      <!-- 左侧：提现表单 -->
      <div class="form-column">
        <el-card shadow="never" class="settlement-card">
          <div slot="header" class="card-header">
            <span><i class="el-icon-coin"></i> 账户提现</span>
          </div>
          <el-form ref="infoForm" :model="form" :rules="rules" label-width="100px" class="settlement-form">
        <div class="container">
          <div class="form-item-wrapper">
            <div class="form-section">
              <el-form-item label="当前余额">
                <span class="balance-amount">￥{{ balance }}</span>
              </el-form-item>
              <el-form-item label="提现通道" prop="ChannelCode">
                <el-select clearable v-model="form.ChannelCode" placeholder="请选择"
                  class="custom-input">
                  <el-option v-for="item in channelList" :key="item.channel_id" :value="item.channel_code"
                    :label="item.channel_name" />
                </el-select>
              </el-form-item>
              <el-form-item label="提现姓名" prop="PayerName">
                <el-input clearable v-model.trim="form.PayerName" placeholder="请输入" />
              </el-form-item>
              <el-form-item label="提现账户" prop="PayerAccount">
                <el-input clearable v-model.trim="form.PayerAccount" placeholder="请输入" />
              </el-form-item>
              <el-form-item label="提现银行" prop="PayerBankName">
                <el-select clearable filterable class="ele-block" v-model="form.PayerBankName" placeholder="请输入">
                  <el-option v-for="item in bankList" :key="item.id" :value="item.id" :label="item.bank_name" />
                </el-select>
              </el-form-item>
              <el-form-item label="提现分行" prop="PayerBankBranchName">
                <el-input v-model.trim="form.PayerBankBranchName" placeholder="请输入" clearable />
              </el-form-item>
              <el-form-item label="提现金额" prop="PaymentAmount">
                <el-input clearable v-model.trim="form.PaymentAmount" placeholder="请输入" />
              </el-form-item>
              <el-form-item v-if="is_google === 0" label="提现密码" prop="cz_password">
                <el-input show-password v-model.trim="form.cz_password" placeholder="请输入" clearable />
              </el-form-item>
              <el-form-item v-else label="谷歌口令" prop="googlecode">
                <el-input clearable v-model="form.googlecode" placeholder="请输入" />
              </el-form-item>
            </div>
            <div class="button-section">
              <el-button type="primary" @click="save" :loading="loading" class="submit-btn">
                <i class="el-icon-check"></i>
                <span>确定</span>
              </el-button>
              <el-button @click="resetForm" class="reset-btn">
                <i class="el-icon-refresh"></i>
                <span>重置</span>
              </el-button>
            </div>
          </div>
        </div>
          </el-form>
        </el-card>
      </div>

      <!-- 右侧：提现进度 -->
      <div class="progress-column">
        <el-card shadow="never" class="progress-card-wrapper">
          <div slot="header" class="card-header">
            <span><i class="el-icon-tickets"></i> 提现进度</span>
            <el-button v-if="progressList.length > 0" type="text" size="small" @click="clearAllProgress">
              <i class="el-icon-delete"></i> 清空
            </el-button>
          </div>
          <div v-if="progressList.length === 0" class="empty-progress">
            <i class="el-icon-document"></i>
            <p>暂无提现记录</p>
          </div>
          <div v-else class="progress-list-container">
            <div v-for="(progress, index) in progressList" :key="index" class="progress-item-compact">
              <div class="progress-header-compact">
                <div class="progress-status">
                  <i class="el-icon-loading" :class="{ 'is-spinning': progress.currentStep === 1, 'processing': progress.currentStep === 1 }"></i>
                  <span class="status-text" :class="{ 'processing': progress.currentStep === 1, 'error': progress.order_status === 2 }">
                    {{ getProgressTitle(progress.currentStep, progress.order_status) }}
                  </span>
                </div>
                <el-button type="text" size="small" @click="removeProgress(index)" class="close-btn-compact">
                  <i class="el-icon-close"></i>
                </el-button>
              </div>

              <el-steps :active="progress.currentStep" class="progress-steps-compact">
                <el-step title="提交成功" :status="getStepStatus(0, progress.order_status)"></el-step>

                <el-step :status="getStepStatus(1, progress.order_status, progress.currentStep)">
                  <template #icon>
                    <i v-if="progress.currentStep === 1" class="el-icon-loading is-spinning step-loading-icon"></i>
                  </template>
                  <template #title>
                    <span :class="{ 'step-title-processing': progress.currentStep === 1 }">
                      提现处理中
                    </span>
                  </template>
                </el-step>
                
                <el-step v-if="progress.merchantOrderNo" :status="getStepStatus(2, progress.order_status, progress.currentStep)">
                  <template #title>
                    <span :class="{ 'step-title-error': progress.order_status === 2 }">
                      {{ getProgressTitle(2, progress.order_status) }}
                    </span>
                  </template>
                </el-step>
              </el-steps>

              <div class="progress-info-compact">
                <span class="order-id">订单：{{ progress.merchantOrderNo }}</span>
                <span class="order-amount">￥{{ progress.paymentAmount }}</span>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'recharge',
  data() {
    return {
      // 表单数据
      form: {
        ChannelCode: ''
      },
      channelList: [],  //支付类型
      balance: 0,//当前余额
      is_google: 0, //是否谷歌验证
      bankList: [],
      // 提现进度列表
      progressList: [],
      // 表单验证规则
      rules: {
        ChannelCode: [
          { required: true, message: 'Please select a settlement type.', trigger: 'blur' }
        ],
        PayerName: [
          { required: true, message: 'For example: Li Si. For English names, use spaces between words.', trigger: 'blur' }
        ],
        PayerAccount: [
          { required: true, message: 'For example: 62222222226789', trigger: 'blur' }
        ],
        PayerBankName: [
          { required: true, message: 'Please enter the bank name.', trigger: 'blur' }
        ],
        PaymentAmount: [
          { required: true, message: 'Please enter the amount.', trigger: 'blur' }
        ],
        cz_password: [
          { required: true, message: 'If you forgot the withdrawal password, please contact customer support.', trigger: 'blur' }
        ],
        googlecode: [
          { required: true, message: 'If you lost your Google Key, please contact support to unbind it.', trigger: 'blur' }
        ]
      },
      // 保存按钮loading
      loading: false
    };
  },
  mounted() {
    // 获取用户信息
    this.getChannelList();
    this.getBalance();
    this.getBankList();
    // 加载未完成的提现进度
    this.loadProgressList();
  },
  methods: {
    //银行列表
    getBankList() {
      this.$http.get('/recharge/getBankList').then(res => {
        if (res.data.code === 0) {
          this.bankList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    //获取当前余额
    getBalance() {
      this.$http.get('/user/getBalance').then(res => {

        if (res.data.code === 0) {
          this.balance = res.data.data.balance;
          this.is_google = res.data.data.is_google;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    getChannelList() {
      this.$http.post('/Outorder/getChannels', {
        type_id: 2
      }).then(res => {
        if (res.data.code === 0) {
          this.channelList = res.data.data;
          if (this.channelList.length > 0) {
            this.form.ChannelCode = this.channelList[0].channel_code;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    /* 保存更改 */
    save() {
      const that = this;
      this.$refs['infoForm'].validate((valid) => {
        if (!valid) return;
        that.loading = true;

        // 前端组装订单号：W + 年月日时分秒 + 5位随机数
        var now = new Date();
        var orderId =
          'W' +
          now.getFullYear() +
          ('0' + (now.getMonth() + 1)).slice(-2) +
          ('0' + now.getDate()).slice(-2) +
          ('0' + now.getHours()).slice(-2) +
          ('0' + now.getMinutes()).slice(-2) +
          ('0' + now.getSeconds()).slice(-2) +
          Math.floor(Math.random() * 90000 + 10000);

        // 将订单号添加到表单数据中
        that.form.merchantOrderNo = orderId;

        that.$http.post('/recharge/outunifiedorder', that.form).then(function (res) {
          that.loading = false;
          if (res.data.code === 0) {
            that.balance = res.data.data.balance;
            const amount = that.form.PaymentAmount;
            that.$message.success('提现申请已提交');
            that.addProgress({
              merchantOrderNo: orderId,
              paymentAmount: amount,
              order_status: 0
            });
            that.$refs.infoForm.resetFields();
            that.getBalance(); // 刷新余额
          } else {
            // 使用弹窗显示错误信息
            that.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定',
              type: 'error',
              callback: () => {}
            });
          }
        }).catch(function (e) {
          that.loading = false;
          // 使用弹窗显示错误信息
          that.$alert(e.message, '提示', {
            confirmButtonText: '确定',
            type: 'error',
            callback: () => {}
          });
        });
      });
    },
    // 添加提现进度
    addProgress(order) {
      if (!order.merchantOrderNo) return;
      // 初始状态：第一步已完成，进入第二步
      var progress = Object.assign({}, order, { currentStep: 1, timer: null });
      this.progressList.unshift(progress);
      this.startPolling(progress);
      this.saveProgressList();
    },
    
    // 启动轮询
    startPolling(progress) {
      const that = this;
      progress.timer = setInterval(function () {
        that.$http.get('/recharge/getOutOrderList', {
          params: { merchantOrderNo: progress.merchantOrderNo }
        })
          .then(function (res) {
            var list = res.data.data || [];
            var item = Array.isArray(list)
              ? list.find(function (i) {
                return i.merchantOrderNo === progress.merchantOrderNo;
              })
              : null;
            if (item) {
              progress.order_status = item.order_status;
              // 如果有结果（成功或失败），跳转到第三步
              if (item.order_status === 1 || item.order_status === 2) {
                progress.currentStep = 2;
                clearInterval(progress.timer);
                progress.timer = null;
              } else {
                // 否则保持在第二步（提现处理中）
                progress.currentStep = 1;
              }
              that.saveProgressList();
            }
          })
          .catch(function (err) {
            console.error('轮询失败:', err.message);
          });
      }, 5000);
    },
    // 保存进度列表到 localStorage
    saveProgressList() {
      try {
        // 保存所有进度，包括最终状态的进度（页面未刷新时继续显示）
        localStorage.setItem('withdrawProgress', JSON.stringify(this.progressList));
      } catch (e) {
        console.error('保存进度失败:', e);
      }
    },
    // 加载未完成的提现进度
    loadProgressList() {
      const that = this;
      try {
        const localData = localStorage.getItem('withdrawProgress');
        if (localData) {
          const parsed = JSON.parse(localData);
          // ✅ 刷新时自动清除状态为 1 / 2 的订单
          const active = parsed.filter(function (p) {
            return p.order_status !== 1 && p.order_status !== 2;
          });
          this.progressList = active.map(function (p) {
            p.timer = null;
            // 如果有结果，显示第三步；否则显示第二步
            p.currentStep = (p.order_status === 1 || p.order_status === 2) ? 2 : 1;
            return p;
          });
          this.progressList.forEach(function (p) {
            if (p.order_status === 0 || !p.order_status) {
              that.startPolling(p);
            }
          });
          this.saveProgressList();
        }
      } catch (e) {
        console.error('加载进度失败:', e);
      }
    },
    // 移除进度
    removeProgress(index) {
      const p = this.progressList[index];
      if (p && p.timer) clearInterval(p.timer);
      this.progressList.splice(index, 1);
      this.saveProgressList();
    },
    // 清空所有进度
    clearAllProgress() {
      const that = this;
      this.$confirm('确定要清空所有提现记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.progressList.forEach(function (p) {
          if (p.timer) clearInterval(p.timer);
        });
        that.progressList = [];
        localStorage.removeItem('withdrawProgress');
        that.$message.success('已清空所有记录');
      }).catch(() => {});
    },
    
    // 获取进度标题
    getProgressTitle(step, status) {
      if (step === 0) return '提交成功';
      if (step === 1) return '提现处理中';
      if (step === 2) {
        if (status === 1) return '提现成功';
        if (status === 2) return '提现失败';
        return '提现结果';
      }
      return '';
    },
    
    // 获取步骤状态
    getStepStatus(step, status, currentStep) {
      // 如果第三步有结果（成功或失败），所有步骤都显示为成功状态（绿色）
      if (status === 1 || status === 2) {
        return 'success';
      }
      
      // 第一步：提交成功，始终显示为成功
      if (step === 0) {
        return 'success';
      }
      
      // 第二步：提现处理中
      if (step === 1) {
        // 如果当前在第二步，显示为处理中（黄色）
        if (currentStep === 1) {
          return 'processing';
        }
        // 如果已经到第三步，显示为成功
        if (currentStep >= 2) {
          return 'success';
        }
        // 否则等待
        return 'wait';
      }
      
      // 第三步：提现结果
      if (step === 2) {
        if (currentStep >= 2) {
          return 'success';
        }
        return 'wait';
      }
      
      return 'wait';
    },
    resetForm() {
      this.$refs['infoForm'].resetFields();
    }
  }
}
</script>


<style scoped>
/* 主容器布局 */
.main-container {
  display: flex;
  gap: 20px;
}

/* 左侧进度列 */
.progress-column {
  flex: 0 0 400px;
  min-width: 400px;
  display: flex;
  flex-direction: column;
}

.progress-card-wrapper {
  border-radius: 4px;
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: #303133;
}

.progress-card-wrapper ::v-deep .el-card__header {
  padding: 20px;
  border-bottom: 1px solid #ebeef5;
}

.card-header i {
  margin-right: 8px;
  color: #667eea;
}

.empty-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  color: #c0c4cc;
}

.empty-progress i {
  font-size: 64px;
  margin-bottom: 16px;
}

.empty-progress p {
  font-size: 14px;
  margin: 0;
}

.progress-list-container {
  overflow-y: auto;
  flex: 1;
  padding: 20px;
}

.progress-card-wrapper ::v-deep .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.progress-list-container::-webkit-scrollbar {
  width: 6px;
}

.progress-list-container::-webkit-scrollbar-track {
  background: #f5f7fa;
  border-radius: 3px;
}

.progress-list-container::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

.progress-list-container::-webkit-scrollbar-thumb:hover {
  background: #c0c4cc;
}

.progress-item-compact {
  background: #fafbfc;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

.progress-item-compact:hover {
  border-color: #667eea;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
}

.progress-header-compact {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.progress-status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.progress-status i {
  font-size: 20px;
  color: #667eea;
}

.progress-status i.processing {
  color: #E6A23C;
}

.progress-status i.is-spinning {
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.status-text {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.status-text.processing {
  color: #E6A23C;
}

.status-text.error {
  color: #f56c6c;
}

.close-btn-compact {
  padding: 4px;
  color: #909399;
}

.close-btn-compact:hover {
  color: #f56c6c;
}

.progress-steps-compact {
  margin: 12px 0;
}

::v-deep .progress-steps-compact .el-step__head {
  width: 24px;
  height: 24px;
  background-color: #ffffff;
}

::v-deep .progress-steps-compact .el-step__icon {
  font-size: 14px;
  width: 24px;
  height: 24px;
  line-height: 24px;
  background-color: #ffffff;
}

::v-deep .progress-steps-compact .el-step__main {
  padding-left: 0;
}

::v-deep .progress-steps-compact .el-step__title {
  font-size: 12px;
  line-height: 20px;
  font-weight: 500;
}

::v-deep .progress-steps-compact .el-step__line {
  top: 12px;
}

.step-loading-icon {
  color: #E6A23C;
}

.step-title-processing {
  color: #E6A23C;
}

.step-title-error {
  color: #f56c6c;
}

.progress-info-compact {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f2f5;
}

.order-id {
  font-size: 12px;
  color: #909399;
}

.order-amount {
  font-size: 16px;
  font-weight: 700;
  color: #667eea;
}

/* 右侧表单列 */
.form-column {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.settlement-card {
  border-radius: 4px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.settlement-card ::v-deep .el-card__header {
  padding: 20px;
  border-bottom: 1px solid #ebeef5;
}

.settlement-card ::v-deep .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.settlement-form {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.container {
  display: flex;
  justify-content: center;
  flex: 1;
}

.form-item-wrapper {
  width: 100%;
  max-width: 600px;
}


::v-deep .el-step__title {
  font-size: 16px;
  font-weight: 600;
}

::v-deep .el-step__description {
  font-size: 14px;
  color: #909399;
}

/* 第二步：提现处理中 - 黄色背景和边框 */
::v-deep .progress-steps-compact .el-step__head.is-process {
  background-color: #E6A23C !important;
  border-color: #E6A23C !important;
  color: #ffffff !important;
}

::v-deep .progress-steps-compact .el-step__head.is-process .el-step__icon {
  background-color: #E6A23C !important;
  border-color: #E6A23C !important;
  color: #ffffff !important;
}

::v-deep .progress-steps-compact .el-step__icon.is-text.is-process {
  background-color: #E6A23C !important;
  border-color: #E6A23C !important;
  color: #ffffff !important;
}

::v-deep .el-step__head.is-finish {
  color: #67c23a;
  border-color: #67c23a;
}

::v-deep .el-step__title.is-process {
  color: #667eea;
  font-weight: 700;
}

::v-deep .el-step__title.is-finish {
  color: #67c23a;
}

/* 输入框美化 */
.custom-input {
  width: 100%;
  transition: all 0.3s ease;
}

::v-deep .el-input__inner,
::v-deep .el-select .el-input__inner {
  border-radius: 8px;
  font-size: 15px;
}

::v-deep .el-input__inner:focus,
::v-deep .el-select .el-input.is-focus .el-input__inner {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
}

::v-deep .el-select-dropdown__item.selected {
  color: #667eea;
  font-weight: 600;
}

/* 按钮区域 */
.button-section {
  text-align: center;
  margin: 30px 0;
}

.submit-btn,
.reset-btn {
  padding: 14px 40px;
  font-size: 16px;
  border-radius: 12px;
  transition: all 0.3s ease;
  font-weight: 600;
  letter-spacing: 1px;
}

.submit-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.submit-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.6);
}

.submit-btn i,
.reset-btn i {
  margin-right: 8px;
  font-size: 18px;
}

.reset-btn {
  margin-left: 16px;
  background: #f5f7fa;
  color: #606266;
  border-color: #dcdfe6;
}

.reset-btn:hover {
  background: #e6e8eb;
  border-color: #c0c4cc;
  color: #303133;
  transform: translateY(-2px);
}

/* 表单区域 */
.form-section {
  background: #fafbfc;
  padding: 30px;
  border-radius: 16px;
  margin-bottom: 30px;
}

.form-section .el-form-item {
  margin-bottom: 25px;
}

/* 余额显示 */
.balance-amount {
  font-size: 24px;
  font-weight: 700;
  color: #667eea;
  letter-spacing: 1px;
}

/* 响应式 */
@media (max-width: 1200px) {
  .main-container {
    flex-direction: column;
  }

  .progress-column {
    flex: 1;
    min-width: auto;
  }

  .progress-card-wrapper {
    height: 400px;
    border-radius: 4px;
  }

  .settlement-card {
    border-radius: 4px;
  }

  .form-column {
    flex: 1;
  }
}

@media (max-width: 768px) {
  .form-section {
    padding: 20px;
  }

  .submit-btn,
  .reset-btn {
    width: 100%;
    margin: 8px 0;
  }

  .progress-item-compact {
    padding: 12px;
  }

  .progress-steps-compact {
    margin: 8px 0;
  }

  ::v-deep .progress-steps-compact .el-step__title {
    font-size: 12px;
  }

  .order-amount {
    font-size: 14px;
  }
}
</style>

<style>
.el-form-item label {
  font-weight: bold;
  font-size: 16px;
}
</style>
